import { Observable } from "rxjs";
import * as http from "../../../../../../../services/http.service";
import { FlyerDetailCreatePageResponse } from "../types/flyer-detail-create-page-response.interface";

export function createPage(
  flyerId: number,
  templateId: number
): Observable<FlyerDetailCreatePageResponse> {
  return http.post(`/pages/`, {
    flyer: flyerId,
    pageTemplate: templateId,
  });
}
